import { AppRegistrationSection } from '../../AppRegistrationSection';
import { frameConfigBasic } from '../../AppConfig';
import { getScreenTranslation } from '../../utils/translations';
import { RequestLoadingTemplate } from 'InternalLibrary';
import { useTranslation } from 'react-i18next';

export default function RegistrationLoading() {
  const i18Next = useTranslation();
  return (
    <RequestLoadingTemplate
      {...frameConfigBasic}
      hideLogout
      hideMobileFooter
      content={getScreenTranslation('registration_loading', i18Next)}
      sectionID={AppRegistrationSection.Confirmation}
    />
  );
}
